import { Button } from '@/components';
import { queryKeyMap } from '@/features/project/_utils/query-keys';
import { useRemoveQueries } from '@/hooks';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { z } from 'zod';
import {
  type BatchModel,
  PaymentGroupUploadParamsSchema,
} from '../../_models/batch';

type Props = {
  batchParams: z.infer<typeof BatchModel>['params'];
};

export const BatchPaymentGroupUploadContent: FC<Props> = ({ batchParams }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { removeQuery } = useRemoveQueries();
  return (
    <Button
      type="link"
      onClick={() => {
        const projectId =
          PaymentGroupUploadParamsSchema.parse(batchParams).projectPk;
        removeQuery(queryKeyMap.paymentGroups(projectId));
        removeQuery(queryKeyMap.paymentGraphData(projectId));
        removeQuery(queryKeyMap.contractorPayments(projectId));
        navigate(`/rs/project/${projectId}?activeKey=payment`);
      }}
    >
      {t('move-to', { target: t('payment-detail') })}
    </Button>
  );
};
